import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id EDAD5377-8923-4D6C-AC12-CBDC6C78DC7F
 * name cursor-move
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cursor-move.svg
 * tags
 */
export const CursorMoveIcon = createSvgIcon(<><path d="M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z" /></>, 'CursorMoveIcon');
export default CursorMoveIcon